import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './jsonEditor.css';
import { Button, Form } from 'semantic-ui-react';

const EditorNodeReaderView = React.memo(
  ({ node, index, onEdit, onMove, onDelete, onRowClick, isSelected, isLast }) => {
    const handleMoveUp = () => {
      if (index > 0) {
        onMove({ startIndex: index, indexOfTarget: index - 1 });
      }
    };

    const handleMoveDown = () => {
      onMove({ startIndex: index, indexOfTarget: index + 1 });
    };

    const handleRowClick = () => {
      if (onRowClick) {
        onRowClick(node, index);
      }
    };

    // Returns the category label derived from the node type. Pass-through if
    // node.type has been replaced by a highlighted React node (during search).
    const getCategoryFromType = (node) => {
      if (typeof node.type !== 'string') return node.type;
      switch (node.type) {
        case 'dialogue':
          return 'Dialogue';
        case 'narration':
          return 'Narration';
        case 'initialize':
          return 'Initializing';
        case 'bookPart':
          return 'Book Part';
        case 'chapter':
          return 'Chapter';
        default:
          return node.type;
      }
    };

    // Builds the numbered-line summary like:
    //   "1:  Jamis - frustrated - Dialogue"
    //   "2:  Narration"           (no speaker, no emotion)
    //   "3:  Book Part"
    // Empty parts are skipped so we never get stray dashes.
    const buildLineSummary = (node) => {
      const parts = [];
      if (node.speaker) parts.push(node.speaker);
      if (node.emotion) parts.push(node.emotion);
      const category = getCategoryFromType(node);
      if (category) parts.push(category);
      // React-friendly join with ' - ' that tolerates highlighted React nodes
      return parts.reduce((acc, part, i) => {
        if (i === 0) return [part];
        acc.push(' - ', part);
        return acc;
      }, []);
    };

    return (
      <div
        className={isLast ? 'reader-editor-node noBottomBorder' : 'reader-editor-node'}
        onClick={handleRowClick}
        style={{ cursor: 'pointer' }}
      >
        <div className="reader-data-container" >
          <div className="character-emotion">
            <span>{`${index + 1}:  `}{buildLineSummary(node)}</span>
          </div>
          <div className="text-field-viewer-container" style={{ borderRight: "1px solid #ececec" }} >
            <div className="text-field-viewer">
              <Form>
                {/* Instead of a TextareaAutosize, render a div that accepts children */}
                <div
                  style={{
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    width: '100%',
                    whiteSpace: 'pre-wrap',
                    backgroundColor: "#ffffff",
                    paddingLeft: "5px",
                    paddingRight: "5px",

                    marginLeft: "19px",
                    borderRadius: "5px"
                  }}
                >
                  {node.content}
                </div>
              </Form>
            </div>
            <div className="action-container" style={{
              backgroundColor: "#FFFFFF", marginTop: "-33px", paddingTop: "5px",
              borderTop: "1px solid #ececec", borderLeft: "1px solid #ECECEC"
            }}>
              <div className="reader-view-actions" >
                <Button
                  basic
                  type="button"
                  icon="edit"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit(index);
                  }}
                  className={`no-padding-border-button ${isSelected ? 'icon-button.selected' : 'icon-button'}`}
                />
                <Button
                  basic
                  type="button"
                  icon="arrow up"
                  className="up-dwn-icon-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMoveUp();
                  }}
                />
                <Button
                  basic
                  type="button"
                  icon="arrow down"
                  className="up-dwn-icon-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMoveDown();
                  }}
                />
                <Button
                  basic
                  type="button"
                  icon="trash"
                  className="no-border-trash-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(index);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default EditorNodeReaderView;
